import { PlanFamily, ProductFeature } from './generated';
import { FEATURE_PER_FAMILY } from './plans';
import { SERVICE_NAME } from './serviceName';

const AWS_PROVIDER_PREFIX = `${ProductFeature.FEATURE_LOCALSTACK_AWS_PROVIDER}/`;
// Snowflake is registered as a AWS provider but in reality is not, see https://github.com/localstack/localstack-platform/pull/1276
const FAKE_AWS_PROVIDERS = ['snowflake'];
const REMOVED_SERVICES_THAT_ARE_STILL_IN_THE_LICENSE = ['iotanalytics', 'elastictranscoder', 'mediastore'];

const isAwsProviderFilter = (item: string) => item.startsWith(AWS_PROVIDER_PREFIX);
const isNotFakeAwsProvider = (item: string) =>
  !FAKE_AWS_PROVIDERS.some((fake) => item.startsWith(AWS_PROVIDER_PREFIX + fake));
const isNotRemovedServiceButStillInLicense = (item: string) =>
  !REMOVED_SERVICES_THAT_ARE_STILL_IN_THE_LICENSE.some((removed) => item.startsWith(AWS_PROVIDER_PREFIX + removed));

const LICENSE_AWS_SERVICES_FILTERS = [isAwsProviderFilter, isNotFakeAwsProvider, isNotRemovedServiceButStillInLicense];

export const AWS_SERVICES_LIST = Array.from(
  new Set(
    FEATURE_PER_FAMILY[PlanFamily.ULTIMATE_PLANS]
      .filter((f) => LICENSE_AWS_SERVICES_FILTERS.every((func) => func(f)))
      .map((f) => f.slice(AWS_PROVIDER_PREFIX.length).split(':')[0]),
  ),
) as SERVICE_NAME[];
